<template>
  <div>
    <router-link :to="{ name: 'applicant-educations', query: { applicant_id: applicant.resource_id }}" class="blue_text" target="_blank">
      <b><u>לימודים:</u></b>
    </router-link>
    <div v-if="educations.length > 0">
      <p v-for="education in educations" @click="editEducation(education)" class="blue_text btn" :key="education.id">
        <b>({{education.year_start + '-' + education.year_end}}):</b>
        {{education.education_institution.name}},
        <b>ציון:</b>
        {{education.grade}},
        <b>קורס:</b>
        {{education.education_course.name}}
      </p>
    </div>
    <p v-else>לימודים לא הוזנו</p>
    <a @click="createEducation" class="button is-info">Create Education</a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'applicant-educations',
  props: {
    applicant: {
      type: Object,
      default: () => ({})
    },
    educations: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    editEducation (education) {
      this.create({ designator: 'applicant-educations-form-modal', component_name: 'ApplicantEducationsForm', data: education, applicant_id: this.applicant.resource_id, modal_title: education.education_institution.name })
    },
    createEducation () {
      this.create({ designator: 'applicant-educations-form-modal', component_name: 'ApplicantEducationsForm', is_create: true, applicant_id: this.applicant.resource_id, modal_title: 'Create new Education' })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
